function initialiseGooglePhotosTooltip () {
  $(".google-places-tooltip-icon").focus(function () {
    var tooltip = $(this).parent().find(".google-places-tooltip");
    tooltip.toggleClass("m-fadeIn");
  });

  $(".google-places-tooltip-icon").focusout(function () {
    var tooltip = $(this).parent().find(".google-places-tooltip");
    if (tooltip.hasClass("m-fadeIn")) {
      tooltip.toggleClass("m-fadeIn");
    };
  });
};

$(function () {
  initialiseGooglePhotosTooltip();
  OT.Events.on('results:done', function(){
    initialiseGooglePhotosTooltip();
  });
});
